import { render } from "./profile-mobile-footer-nav.vue?vue&type=template&id=5772d664&scoped=true"
import script from "./profile-mobile-footer-nav.vue?vue&type=script&lang=js"
export * from "./profile-mobile-footer-nav.vue?vue&type=script&lang=js"

import "./profile-mobile-footer-nav.vue?vue&type=style&index=0&id=5772d664&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5772d664"]])

export default __exports__